module.exports = __webpack_public_path__ + "media/images/premium/premium_ui_tw_04-900-99a82dab8b626c2f5302868232804a1e.png";